/* src/app/private/configrations/roll-number-configuration/roll-number-configuration.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
/*# sourceMappingURL=roll-number-configuration.component.css.map */
